{
  "stay_in_touch": {
    "button": "Rester en contact",
    "modal_title": "Rester en contact",
    "set_frequency": "Définir la fréquence",
    "no_reminders_set": "Vous n'avez défini aucun rappel Rester en contact",
    "due_date": "Date d'échéance",
    "contact": "Contact",
    "firm": "Cabinet",
    "last_interaction": "Dernière interaction",
    "select_frequency": "Sélectionner la fréquence",
    "reminder_active_message": "Le rappel Rester en contact est actif, et les contacts ont été ajoutés à Mes contacts.",
    "stay_in_touch_aria_label": "Rester en contact"
  },
  "contacts": {
    "actions": {
      "add_to_my_contact": "Ajouter à Mes contacts",
      "add_contact": "Ajouter un contact",
      "remove_confirmation": "Êtes-vous sûr de vouloir supprimer ce contact",
      "remove_title": "Veuillez confirmer la suppression du contact",
      "export_contacts": "Exporter les contacts"
    },
    "table": {
      "columns": {
        "contact": "Contact",
        "company": "Entreprise",
        "location": "Localisation",
        "tags": "Étiquettes",
        "last_interaction": "Dernière interaction"
      },
      "selection": {
        "all_selected": "Tous les {{count}} contacts sélectionnés",
        "add_to_list": "Ajouter à la liste",
        "archive": "Archiver",
        "log_new_activity": "Enregistrer une nouvelle activité",
        "add_to_list_success": "Demande envoyée. Il peut falloir quelques minutes pour voir tous les contacts dans la liste cible"
      }
    },
    "states": {
      "empty": {
        "title": "Aucun contact à examiner",
        "description": "Les nouveaux contacts apparaîtront ici pour votre examen",
        "alt_text": "Aucun contact à examiner",
        "description_list": "Aucun contact à afficher ici"
      },
      "not_found": {
        "title": "Aucun contact trouvé",
        "description": "Nous n'avons trouvé aucun contact correspondant à votre recherche",
        "alt_text": "Succès"
      }
    },
    "filters": {
      "company_type": "Type d’entreprise",
      "consent_status": "Statut du consentement",
      "company_hierarchy": "Hiérarchie de l’entreprise"
    },
    "forms": {
      "email_label": "E-mail",
      "email_required": "L'e-mail est requis",
      "email_invalid": "Ceci n'est pas un e-mail"
    },
    "export": {
      "title": "Mes contacts",
      "description": "Ajouter mes contacts à la liste",
      "primary_view": "vue de mes contacts"
    },
    "tabs": {
      "my_contacts": "Mes contacts"
    },

    "order_by": {
      "label": "Trier par"
    },
    "aria_labels": {
      "is_private_contact": "Contact privé",
      "view_contact_hierarchy": "voir la hiérarchie des contacts"
    }
  },
  "prospects": {
    "actions": {
      "search_prospects": "Rechercher des prospects"
    },
    "tabs": {
      "my_prospects": "Mes prospects"
    }
  },
  "opportunities": {
    "tabs": {
      "my_opportunities": "Mes opportunités"
    },
    "filters": {
      "referral_source": "Source de recommandation",
      "date": "Date"
    }
  },
  "companies": {
    "actions": {
      "remove_confirmation": "Êtes-vous sûr de vouloir supprimer cette entreprise",
      "remove_title": "Veuillez confirmer la suppression de cette entreprise",
      "remove_from_my_companies": "Supprimer de mes entreprises"
    },
    "order_by": {
      "label": "Trier par"
    },
    "filters": {
      "type": "Type"
    },
    "states": {
      "empty": {
        "description": "Aucune entreprise à afficher ici"
      }
    },
    "tabs": {
      "my_companies": "Mes entreprises"
    },
    "export": {
      "primary_view": "vue de mes entreprises"
    }
  }
}
